module.exports = __webpack_public_path__ + "static/media/image-video-7.a8cd9d10.png";